var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { PeekGrid, PeekInput, PeekStack } from "@piiqtechnologies/ui-components";
import { Field } from "formik";
import React from "react";
const FormFields = (_a) => {
    var { fields } = _a, props = __rest(_a, ["fields"]);
    return (React.createElement(PeekStack, { direction: "column", justifyContent: "space-between", textAlign: "left" }, fields.map(({ id, label, placeholder, required, type, component: FormComponent, multiline, rows }) => {
        return (React.createElement(Field, Object.assign({ id: id, key: id, name: id, label: label, type: type && type, placeholder: placeholder, required: required, component: FormComponent || PeekInput, multiline: multiline, rows: rows }, props)));
    })));
};
export const MultiColumnFormFields = (_a) => {
    var { fields, rowSpacing, alignItems } = _a, props = __rest(_a, ["fields", "rowSpacing", "alignItems"]);
    return (React.createElement(PeekGrid, { container: true, direction: "column", rowSpacing: rowSpacing }, Object.entries(fields).map(([rowKey, rowFields]) => (React.createElement(PeekGrid, { item: true, container: true, key: rowKey, alignItems: alignItems || "flex-start", direction: "row", columnSpacing: 1.5 }, rowFields.map((_a) => {
        var { id, label, placeholder, required, type, component, columns, multiline, rows, fullWidth, style } = _a, fieldProps = __rest(_a, ["id", "label", "placeholder", "required", "type", "component", "columns", "multiline", "rows", "fullWidth", "style"]);
        return (React.createElement(PeekGrid, { style: style, key: id, item: true, xs: columns },
            React.createElement(Field, Object.assign({ id: id, name: id, label: label, type: type && type, placeholder: placeholder, required: required, multiline: multiline, rows: rows, component: component || PeekInput, fullWidth: fullWidth }, fieldProps, props))));
    }))))));
};
export default FormFields;
